module.exports = __webpack_public_path__ + "assets/img/B2.36e1b4b2.png";